import { useEffect } from 'react';
import {
  // Divider,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  // Box,
} from '@mui/material';

import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';

import GradingOutlinedIcon from '@mui/icons-material/GradingOutlined';

// import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AppSidebarLayout from '../shared/AppSidebarLayout';
import { Outlet, useLocation, useNavigate } from 'react-router';
// import { useAuth } from '../../providers/AuthContext';
// import APP_ROLES from '../AppRoles';

function Cartographer(): React.JSX.Element {
  // const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const app: string | undefined = location.pathname.split('/').at(-1);
  useEffect(() => {
    if (app === 'cartographer') {
      navigate('/cartographer/plot');
    }
  }, [app, navigate]);

  const NavMenuContent = (
    <>
      <List component='nav'>
        <ListItemButton
          selected={app === 'plot'}
          onClick={() => {
            navigate('/cartographer/plot');
          }}
        >
          <ListItemIcon>
            <GradingOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Document Creator' />
        </ListItemButton>
      </List>
      {/* 
      {(auth?.roles || []).includes(APP_ROLES.ADMIN) ? (
        <>
          <Box sx={{ flexGrow: 1 }} />
          <Divider sx={{ my: 1 }} />
          <List component='nav'>
            <ListItemButton
              onClick={() => {
                navigate('/admin/cartographer');
              }}
            >
              <ListItemIcon>
                <EngineeringOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary='Configuration' />
            </ListItemButton>
          </List>
        </>
      ) : undefined} */}
    </>
  );

  return (
    <AppSidebarLayout
      headerTitle={'Cartographer'}
      HeaderIcon={FactCheckOutlinedIcon}
      SidebarContent={NavMenuContent}
    >
      <Outlet />
    </AppSidebarLayout>
  );
}

export default Cartographer;
